// Ay düzeyindeki etkinlik tarihi (Kaan, 5 Kasım 2026): kaynak yalnız ayı yazıyorsa ("Mart 2027") kayıt ayın ilk ve son
// günüyle saklanır, datePrecision = 'month' olur ve "Mart 2027 · gün netleşiyor" diye gösterilir. Gün uydurulmaz.
export const isMonthOnly = e => e?.datePrecision === 'month';
/** Etkinliğin hâlâ önde olup olmadığına bakılacak gün: ay düzeyinde ayın son günü, aksi hâlde başlangıç. */
export const lastRelevantDate = e => isMonthOnly(e) ? e.endDate || e.startDate : e.startDate;
const PENDING = { tr: 'gün netleşiyor', en: 'day to be confirmed' };
export function monthOnlyText(e, language = 'tr') {
  const lang = language === 'en' ? 'en' : 'tr';
  const d = new Date(`${String(e?.startDate || '').slice(0, 7)}-01T12:00:00Z`);
  if (Number.isNaN(d.valueOf())) return '';
  return `${new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : 'tr-TR', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(d)} · ${PENDING[lang]}`;
}
